<template>
  <div class="header01">
    <div class="logo layout"></div>
  </div>
</template>
<script>
export default {
  name: 'CommonNewHeader'
};
</script>
<style lang="scss" scoped>
.header01 {
  height: 76px;
  width: 100%;
  background: url('~@/assets/images/doExam/bg_a.jpg') repeat-x 0 0;
  .logo {
    width: 1000px;
    margin: 0 auto;
    height: 76px;
    background: url('~@/assets/images/doExam/topHeader.png') no-repeat center 0;
  }
}
</style>
